import React from "react";
import './index.css';
import CircularLoading from "./components/circular-loading/CircularLoading";

function LoadingPage() {
  return (
  <div className="loading-page">
    <h1 className="loading-prompt"><CircularLoading /></h1>
  </div>
  );
}

export default LoadingPage;